/*
 * Pipeline Theme — Custom JS
 * Light homepage enhancements:
 *   1. Stat counter count-up animation (impact grid)
 *   2. Fade-in for sections without built-in AOS (newsletter, logos)
 */

(function () {
  'use strict';

  /* Respect reduced motion */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ============================================================
     1. FADE-IN OBSERVER — for newsletter & logos sections
     ============================================================ */
  function observeFadeIns() {
    var targets = document.querySelectorAll(
      '.section-newsletter .newsletter__contain, [data-section-type="logos"]'
    );
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -30px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ============================================================
     2. STAT COUNTER — count up numbers in impact grid
     ============================================================ */
  function animateCounters() {
    var stats = document.querySelectorAll('.impact-grid__stat');
    if (!stats.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            countUp(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    stats.forEach(function (stat) {
      /* Store original text so we can parse it */
      stat.dataset.originalText = stat.textContent.trim();
      observer.observe(stat);
    });
  }

  function countUp(el) {
    var text = el.dataset.originalText || el.textContent.trim();
    /* Match: optional prefix ($, etc), number with commas, optional suffix (+, %, etc) */
    var match = text.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!match) return;

    var prefix = match[1];
    var rawNumber = match[2].replace(/,/g, '');
    var suffix = match[3];
    var target = parseInt(rawNumber, 10);
    if (isNaN(target) || target === 0) return;

    var duration = 1800;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      /* Ease-out cubic for smooth deceleration */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    /* Start from zero */
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(step);
  }

  /* ============================================================
     3. PARALLAX LITE — subtle vertical shift on scroll for images
     ============================================================ */
  function initParallax() {
    var images = document.querySelectorAll('.brick__block .image__fill');
    if (!images.length) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          images.forEach(function (img) {
            var rect = img.getBoundingClientRect();
            var viewH = window.innerHeight;
            /* Only process if in viewport */
            if (rect.bottom > 0 && rect.top < viewH) {
              var center = (rect.top + rect.bottom) / 2;
              var offset = ((center / viewH) - 0.5) * -20; /* max +-10px */
              img.style.transform = 'translateY(' + offset + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    observeFadeIns();
    animateCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
